module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "logo-1.ed8b7b1c.png";